import { render, staticRenderFns } from "./cart_item_header.vue?vue&type=template&id=2b279111&"
import script from "./cart_item_header.vue?vue&type=script&lang=js&"
export * from "./cart_item_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports